import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  colors: [],
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_WIDGET_COLOR:
      return {
        ...state,
        colors: [...action.colors],
      };
    default:
      return state;
  }
}